<template lang="pug">
  .epcis-facet
    checkbox-facet(
      item-value="epci"
      name="EPCIS"
      :options="metrics.epcis"
      :values="formattedValues"
      @change="updateSelection"
    )
</template>

<script>
import facetMixin from './facetMixin.js';

export default {
  mixins: [facetMixin],
  data() {
    return {
      filterId: 'epcis',
      filterType: 'epcis',
    };
  },
  methods: {
    getFormattedValues(selection) {
      return selection.map(it => it.epci);
    },
    getFormattedSelection(values) {
      return values.map(it => { return { epci: it }; });
    },
  },
};
</script>

<style lang="scss" scoped>
  .epcis-facet {
    
  }
</style>